import { ReportsService } from '../reports.service';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const ReportResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  reportsService: ReportsService = inject(ReportsService)
): Observable<any> => {
  const reportId = route.queryParamMap.get('reportId');
  if (!reportId) return null;
  if (reportsService.lastReport && reportId === reportsService.lastReport.id) return reportsService.lastReport;

  return reportsService.getReport(reportId).pipe(
    tap((report) => {
      reportsService.setLastReport(report);
      return report;
    })
  );
};
